import React, { useEffect, useRef } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import uuid from "react-uuid";
import ToolTip from "../../ToolTip/Tooltip";
import { SvgComponent } from "../../SvgComponent/SvgComponent";
import {useQueryParams} from "../../../Hooks/useQueryParams";
import { useTheme } from "../../../Hooks";
import IconButton from "../../IconButton/IconButton";
import { AnimatedIconButton } from "../../AnimatedIconButton/AnimatedIconButton";
import { ComponentStackHelper } from "../../../Utils";
function EditHeader(props) {
    const _uuid = uuid();
    const ref = useRef(null);
    const { theme } = useTheme();
    const navigate = useNavigate();
    const URLParameters = useQueryParams();
    const Id = URLParameters.get("Id");

    var _grabar = props.grabar;

    useEffect(() => {
        ComponentStackHelper.add(_uuid);
        window.addEventListener("keydown", onEvent);
        return () => {
            ComponentStackHelper.remove(_uuid);
            window.removeEventListener("keydown", onEvent);
        };
    }, []);

    const onEvent = (e) => {
        try {
            // este return fue agrega para evitar ejecutar el evento en lo que arreglamos el ComponentStack
            return;
            if ((e.metaKey || e.ctrlKey) && e.code === "KeyS") {
                e.preventDefault();
                e.stopPropagation();
                if (ComponentStackHelper.isActive(_uuid) && props.grabar) {
                    _grabar();
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    function back() {
        navigate(-1);
    }

    return (
        <div
            ref={ref}
            style={{
                position: `sticky`,
                top: `${props.Top ? props.Top : "48px"}`,
                zIndex: 200,
                display: props.esModal ? "none" : "",
                maxHeight: "50px",
            }}
        >
            <Card.Header
                style={{
                    background: "white",
                    padding: "0.3em 1em 0.3em 1em",
                    borderBottom: "1px solid  #e3e3e3",
                }}
            >
                <div className="d-flex justify-content-between">
                    <div
                        className=" d-flex w-50 align-content-center"
                        style={{
                            alignSelf: "center",
                            alignItems: "center",
                        }}
                    >
                        {props.volver && !props.esView && (
                            <IconButton onClick={back}>
                                <ToolTip message="Volver">
                                    <div>
                                        <SvgComponent width="30" height="30" iconName="back" />
                                    </div>
                                </ToolTip>
                            </IconButton>
                        )}
                        <Card.Title as="h4" className="d-inline font-weight-bold">
                            {(props.titulo ?? "") +
                                (Id && !props.hideIdSec ? ` (Id: ${Id})` : "")}
                        </Card.Title>
                    </div>
                    <div className="d-flex w-25 justify-content-end">
{/*                        {props.reloj && (
                            <>
                                <div
                                    style={{
                                        fontSize: "30px",
                                        paddingRight: "10px",
                                        maxHeight: "30px",
                                    }}
                                >
                                    {props.timer}
                                </div>
                                <RelojTrabajoButton
                                    key="Reloj de Trabajo"
                                    message="Reloj de Trabajo"
                                    icon="clock"
                                    onClick={props.reloj}
                                    IconSize="38px"
                                    Size="38px"
                                    relojTrabajoActive={props.relojTrabajoActive}
                                    timer={props.timer}
                                />
                            </>
                        )}*/}
                        {props.generarCuenta && (
                            <AnimatedIconButton
                                size="38px"
                                height="36px"
                                width="36px"
                                iconName="id-card"
                                message="Generar Cuenta/Contacto"
                                onClick={props.generarCuenta}
                            />
                        )}
                        {props.nuevoDetalle && (
                            <IconButton onClick={props.nuevoDetalle}>
                                <ToolTip message="Nuevo Detalle">
                                    <i
                                        style={{
                                            fontSize: "30px",
                                            color: `${theme.color1}`,
                                        }}
                                        className="fa-solid fa-file-circle-plus"
                                    ></i>
                                </ToolTip>
                            </IconButton>
                        )}

                        {props.grabar && (
                            <AnimatedIconButton
                                size="38px"
                                height="20px"
                                width="20px"
                                iconName="Save"
                                message="Grabar"
                                onClick={props.grabar}
                                disabled={props.disabled}
                            />
                        )}
                        {props.iniciarLlamada && (
                            <AnimatedIconButton
                                size="38px"
                                height="20px"
                                width="20px"
                                iconName="call"
                                message="Iniciar Llamada"
                                onClick={props.iniciarLlamada}
                            />
                        )}

                        {props.concluirLlamada && (
                            <AnimatedIconButton
                                size="38px"
                                height="20px"
                                width="20px"
                                iconName="close-call"
                                message="Concluir Llamada"
                                onClick={props.concluirLlamada}
                            />
                        )}
                        {props.actionButtons &&
                            props.actionButtons
                                .sort((a, b) => a.order - b.order)
                                .map((m) => {
                                    return (
                                        <AnimatedIconButton
                                            size="38px"
                                            height="20px"
                                            width="20px"
                                            iconName={m.iconName}
                                            key={m.iconName + m.buttonMessage}
                                            message={m.buttonMessage}
                                            onClick={m.onClick}
                                        />
                                    );
                                })}
                    </div>
                </div>
            </Card.Header>
        </div>
    );
}
export default EditHeader;